<template>
  <div v-if="limits.type === 'limited'">
    <base-progress v-if="percentLeft>0 || limits.additionalLimitCount > 0" :type="(percentLeft>20) ? 'success' : 'warning'"
                   :show-percentage="false"
                   class="pt-0"
                   :value="percentLeft"/>
    <span v-else class="text-danger text-xs">Guthaben aufgebraucht!<br></span>
    <span v-if="limits.requests > limits.limitCount" class="text-xs text-muted">{{limits.requests}} / {{limits.limitCount + additionalLimitsCalculated}} ({{limits.limitCount}} + {{ additionalLimitsCalculated }})</span>
    <span v-else class="text-xs text-muted">{{limits.requests}} / {{limits.limitCount}}</span>

  </div>
  <div v-else-if="limits.type === 'unlimited'">
    {{limits.requests}} / <font-awesome-icon icon="infinity"></font-awesome-icon>
  </div>
  <div v-else>
    <font-awesome-icon icon="circle-notch" size="1x" spin/>
  </div>
</template>

<script>
  export default {
    name:"limits",
    props: {
      location:  {
        type: Number,
        description: "location id",
        }
    },
    data() {
      return {
        limits: {
          location: null,
          requests: 0,
          limitCount: 0,
          additionalLimitCount: 0,
          totalLimit: 0,
          requestsLeft: 0,
          type: "loading"

        },
        refreshTimer: null
      }
    },
    created() {
      this.refreshData();
    },
    computed: {
      percentLeft() {
        return (this.limits.requests > this.limits.limitCount) ?
            (1 - this.limits.requests / (this.limits.limitCount + this.limits.additionalLimitCount + this.limits.requests - this.limits.limitCount)) * 100 :
            (1 - this.limits.requests / this.limits.limitCount) * 100;
      },
      additionalLimitsCalculated() {
        return (this.limits.additionalLimitCount + this.limits.requests - this.limits.limitCount)
      }
    },
    methods: {
      refreshData() {
        this.limits.type ='loading';
        this.getLimits(this.location).then(r =>{
          this.limits = r.response;
        })
      },
      getLimits(location) {
        return new Promise((resolve, reject) => {
          const header = this.authHeader();
          header['Content-Type'] = 'application/json';
          const requestOptions = {
            method: 'GET',
            headers: header
          };

          fetch(process.env.VUE_APP_API_SERVER + `/stats/limits/`+ location, requestOptions)
              .then(this.handleResponse)
              .then(response => {
                resolve({response
                });
              }, error => {reject(error); });
        });

      }
    }
  }
</script>

<style scoped>

</style>